import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { supportedCurrencies } from '../web/utilities/utilities';
import {
  PAYMENT_METHODS,
  PAYMENT_GATEWAYS,
} from '../ReduxStorage/PaymentTransaction/constants';

export const CurrencyPropType = PropTypes.oneOf(supportedCurrencies);
export const CurrencyOptionsPropType = PropTypes.arrayOf(CurrencyPropType);

export const PurchaseItemPropType = ImmutablePropTypes.mapContains({
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  description: PropTypes.string,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  data: PropTypes.object,
});

export const PaymentTransactionPropType = ImmutablePropTypes.mapContains({
  purchaseItems: ImmutablePropTypes.listOf(PurchaseItemPropType).isRequired,
  subtotal: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  requiresPrePermission: PropTypes.bool.isRequired,
  termsConditionsUrl: PropTypes.bool.isRequired,
});

export const MOLPayResponsePropType = ImmutablePropTypes.mapContains({
  type: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  returnUrl: PropTypes.string.isRequired,
  returnLabel: PropTypes.string.isRequired,
  error: PropTypes.object,
});

export const SubscriptionPlanPropType = ImmutablePropTypes.mapContains({
  type: PropTypes.string.isRequired,
  billingCycle: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  currency: CurrencyPropType.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  path: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
  contactInfo: PropTypes.object,
});

export const UserSubscriptionPlanPropType = ImmutablePropTypes.mapContains({
  planId: PropTypes.string,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  nextPaymentDate: PropTypes.string,
  expiryDate: PropTypes.string,
  subscriptionPlan: SubscriptionPlanPropType,
});

export const PaymentMethodPropType = PropTypes.oneOf(PAYMENT_METHODS);
export const PaymentMethodsPropType = ImmutablePropTypes.listOf(
  PropTypes.oneOf(PAYMENT_METHODS)
);

export const PaymentGatewayPropType = PropTypes.oneOf(PAYMENT_GATEWAYS);

export const PaymentErrorPropType = PropTypes.shape({
  paymentData: PropTypes.shape({
    payment_type: PropTypes.string.isRequired,
    payment_processor: PropTypes.string.isRequired,
  }),
});
